import { useReactQuery } from "components/RemoteData";

import { httpService } from "utils";

import { IRegistrationConfirmationResponse } from "../application/types/IRegistrationConfirmationResponse";

export const useRegistrationConfirm = (tokenId: string) => {
  return useReactQuery<IRegistrationConfirmationResponse>(
    registrationConfirmKey(tokenId),
    () => registrationConfirm(tokenId),
    {
      refetchOnWindowFocus: false,
    }
  );
};

const registrationConfirm = (
  token: string
): Promise<IRegistrationConfirmationResponse> => {
  return httpService().post<IRegistrationConfirmationResponse>(
    `/e-reservation/account-activation/${token}`
  );
};

const registrationConfirmKey = (tokenId: string) => {
  return [`registration-confirmation-${tokenId}`];
};
